import { localizedNumber } from "shared/numberParser";
import { defaultArrowAnnotationLeft, defaultArrowAnnotationTop, defaultGridColor, defaultHoverLabel, defaultPlotConfig, defaultSpikeConfig, defaultTickFont, } from "shared/plotly/defaultConfigs";
import * as colors from "styles/colorValues.module.scss";
const { decimal, group } = localizedNumber.numberSeparators;
export const plotConfig = {
    ...defaultPlotConfig,
    showAxisDragHandles: false,
    showAxisRangeEntryBoxes: false,
    scrollZoom: false,
};
const defaultAxisConfig = {
    tickfont: defaultTickFont,
    zeroline: false,
    linewidth: 1,
    tickwidth: 1,
    gridcolor: defaultGridColor,
    linecolor: colors.s900,
};
export const plotLayout = {
    autosize: true,
    dragmode: false,
    hovermode: "closest",
    showlegend: false,
    hoverlabel: defaultHoverLabel,
    paper_bgcolor: "transparent",
    plot_bgcolor: "transparent",
    margin: {
        l: 68,
        r: 10,
        b: 32,
        t: 12,
    },
    separators: `${decimal}${group}`,
    annotations: [{ xshift: -0.5, ...defaultArrowAnnotationTop }, defaultArrowAnnotationLeft],
    xaxis: {
        ...defaultAxisConfig,
        ...defaultSpikeConfig,
    },
    yaxis: defaultAxisConfig,
};
export const prepareMainTrace = (points, variableName) => ({
    x: points.map(({ x }) => x),
    y: points.map(({ y }) => y),
    line: { color: colors.s800 },
    mode: "lines+markers",
    type: "scatter",
    marker: { opacity: 0, size: 4 },
    hovertemplate: `<b>${variableName}</b><br>%{x}, %{y}<extra></extra>`,
});
export const prepareAdditionalTraces = (tracesPoints) => tracesPoints.map((points) => ({
    x: points.map(({ x }) => x),
    y: points.map(({ y }) => y),
    mode: "lines+markers",
    fill: "toself",
    fillcolor: colors.ab10,
    line: { color: "transparent" },
    type: "scatter",
    marker: { opacity: 0, size: 4 },
    hoverinfo: "skip",
}));
